export enum QueryParams {
  EXPIRES_AT = 'e',
  INVITATION_TOKEN = 'i',
  LOGIN_TOKEN = 't',
  NOTIFICATION_GROUP_ID = 'n',
  USER_ID = 'u',
  OVERRIDE_API_ENDPOINT = 'OVERRIDE_API_ENDPOINT',
}
